import WebApp from "@twa-dev/sdk";

/**
 * @deprecated Use `getCloudStorageItem` instead
 */
export async function getItemFromCloudStorage(
  key: string,
): Promise<string | undefined> {
  return new Promise((resolve, reject) => {
    WebApp.CloudStorage.getItem(key, (error, value) => {
      if (error) {
        console.error("Ошибка при получении", key);
        reject(error);
      } else {
        resolve(value);
      }
    });
  });
}
